export default {"src":"/_next/static/media/pancakes.385eb587.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};